import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionFavoritesOption } from '../keys/permissionFavorites.enum';
import { PermissionOption } from '../models/permissionOption.interface';

export const permissionFavorites: PermissionOption[] = [
  {
    code: 'PXXX',
    option: PermissionFavoritesOption.FAVORITES_COMMON_LOGIN,
    permissions: ['favorite.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P330',
    option: PermissionFavoritesOption.FAVORITES_MANAGE_LIST,
    permissions: ['favorite.manage.list'],
  },
  {
    code: 'P331',
    option: PermissionFavoritesOption.FAVORITES_MANAGE_CREATE,
    permissions: ['favorite.manage.create'],
  },
  {
    code: 'P332',
    option: PermissionFavoritesOption.FAVORITES_MANAGE_EDIT,
    permissions: ['favorite.manage.edit'],
  },
  {
    code: 'P333',
    option: PermissionFavoritesOption.FAVORITES_MANAGE_DELETE,
    permissions: ['favorite.manage.remove'],
  },
  {
    code: 'P334',
    option: PermissionFavoritesOption.FAVORITES_MANAGE_ADD,
    permissions: ['favorite.manage.create'],
  },
  {
    code: 'P335',
    option: PermissionFavoritesOption.FAVORITES_MANAGE_SAVE,
    permissions: ['favorite.manage.edit'],
  },
];
